<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement" style="padding-top:100px">
<p style="text-indent:0em"><em>Be generous</em></p>
<p style="text-indent:0em"><em>and you will be prosperous.</em></p>
<p style="text-indent:0em"><em>Help others,</em></p>
<p style="text-indent:0em"><em>and you will be helped.</em></p>
<p style="text-align: right;"><em>– King Solomon (Proverbs 11:25: Good News Bible)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?053718ce